import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/apiClient";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [state, setState] = useState("checking"); // checking, paid, failed
  const polls = useRef(0);

  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get("session_id");
    if (!sessionId) { setState("failed"); return; }

    const poll = async () => {
      if (polls.current >= 8) { setState("failed"); return; }
      polls.current += 1;
      try {
        const res = await api.get(`/payments/status/${sessionId}`);
        if (res.data.payment_status === "paid") { setState("paid"); return; }
        if (["failed", "expired"].includes(res.data.payment_status)) { setState("failed"); return; }
      } catch {}
      setTimeout(poll, 2000);
    };
    poll();
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground grain flex items-center justify-center p-5">
      <div className="max-w-md w-full bg-[#18181b] border border-white/10 rounded-sm p-8 text-center" data-testid="payment-success-page">
        {state === "checking" && (
          <>
            <Loader2 className="h-12 w-12 animate-spin text-primary mx-auto mb-5" />
            <h1 className="font-display text-3xl tracking-tight">CONFIRMING PAYMENT…</h1>
            <p className="text-muted-foreground mt-2">Hang tight, this only takes a moment.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 className="h-14 w-14 text-green-500 mx-auto mb-5" />
            <h1 className="font-display text-4xl tracking-tight">YOU'RE ALL SET!</h1>
            <p className="text-muted-foreground mt-2 mb-6">Your subscription is active. Ava is live and answering for your business.</p>
            <Button data-testid="go-dashboard-btn" onClick={() => navigate("/dashboard")} className="rounded-sm bg-primary hover:bg-orange-600 text-white font-semibold h-11 px-8">Go to Dashboard</Button>
          </>
        )}
        {state === "failed" && (
          <>
            <XCircle className="h-14 w-14 text-destructive mx-auto mb-5" />
            <h1 className="font-display text-3xl tracking-tight">PAYMENT NOT CONFIRMED</h1>
            <p className="text-muted-foreground mt-2 mb-6">We couldn't confirm your payment. You can try again from billing.</p>
            <Button onClick={() => navigate("/dashboard/billing")} className="rounded-sm bg-primary hover:bg-orange-600 text-white font-semibold h-11 px-8">Back to Billing</Button>
          </>
        )}
      </div>
    </div>
  );
}
